$hyoo_mol_ttt $mol_view
	sub / \TTT
